import React, { createContext, useContext, useState, useCallback } from 'react';
import AlertModal from '../components/Common/AlertModal';

const AlertContext = createContext();

export function AlertProvider({ children }) {
  const [alertState, setAlertState] = useState({
    show: false,
    message: '',
    type: 'alert',
    onConfirm: null,
    onCancel: null,
    confirmText: '확인',
    cancelText: '취소',
  });

  const showAlert = useCallback((message, options = {}) => {
    setAlertState({
      show: true,
      message,
      type: 'alert',
      onConfirm: options.onConfirm || null,
      confirmText: options.confirmText || '확인',
      cancelText: '취소',
      onCancel: null,
    });
  }, []);

  const showConfirm = useCallback((message, options = {}) => {
    setAlertState({
      show: true,
      message,
      type: 'confirm',
      onConfirm: options.onConfirm || null,
      onCancel: options.onCancel || null,
      confirmText: options.confirmText || '확인',
      cancelText: options.cancelText || '취소',
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlertState((prev) => ({ ...prev, show: false }));
  }, []);

  const handleConfirm = useCallback(() => {
    const onConfirmCallback = alertState.onConfirm;
    if (onConfirmCallback) {
      onConfirmCallback();
    }
    setAlertState((prev) => ({ ...prev, show: false }));
  }, [alertState]);

  const handleCancel = useCallback(() => {
    const onCancelCallback = alertState.onCancel;
    if (onCancelCallback) {
      onCancelCallback();
    }
    setAlertState((prev) => ({ ...prev, show: false }));
  }, [alertState]);

  return (
    <AlertContext.Provider value={{ showAlert, showConfirm, hideAlert }}>
      {children}
      <AlertModal
        show={alertState.show}
        message={alertState.message}
        type={alertState.type}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        confirmText={alertState.confirmText}
        cancelText={alertState.cancelText}
      />
    </AlertContext.Provider>
  );
}

export function useAlert() {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
}
